import type { FC } from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';
import { NotificationQueueItem, Notification } from '@wix/da-shared-react/pkg/Notifications';
import { NotificationDuration } from '@wix/da-shared-react/pkg/Notifications/Notification';
import SystemNotification from '@wix/da-shared-react/pkg/SystemNotification';
import VideoCreator from '@wix/da-ds/pkg/Icons/VideoCreator';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

import s from './SaveToDraftsNotification.scss';

export interface Props extends Omit<NotificationQueueItem, 'type'> {
  deviation: PapiDeviation;
}

const SaveToDraftsNotification: FC<Props> = ({ id, queueName, deviation }) => {
  const { t } = useTranslation();
  const handleEditClick = useCallback(() => {
    window.open(Url.studio(), '_blank');
  }, []);

  const customIcon = (
    <div className={s['icon-container']}>
      <VideoCreator
        className={s['video-creator-icon']}
        size={IconSize.LARGE}
        disableDefaultColors
      />
    </div>
  );

  return (
    <Notification
      id={id}
      queueName={queueName}
      cardComponent={SystemNotification}
      cardProps={{
        className: s['notification-card'],
        textClassName: s['notification-card-text'],
        iconClassName: s['notification-card-icon'],
        customIcon,
        multiLine: true,
        limitTextWidth: false,
        duration: NotificationDuration.S,
        actions: [
          {
            label: t('studio.videoCreator.savedToDrafts.edit'),
            onClick: handleEditClick,
            closeOnClick: true,
          },
        ],
      }}
    >
      {t('studio.videoCreator.savedToDrafts.success')}
    </Notification>
  );
};
SaveToDraftsNotification.displayName = 'SaveToDraftsNotification';

export default SaveToDraftsNotification;
